import React, { useState } from 'react';
import styles from "./Introduction.module.scss";
import {useSelector,useDispatch} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {RadioSelector, Button,ErrorMsg} from "@onegovbugs/onegov-react-components";
import {isSelected, validate, scrollToError} from "../../../utils/Validation";
import {storeImportExportDetails} from "../../../redux/actions";
import ScrollToTop from "../../../utils/ScrollToTop";
import { RedirectIfCaptchaNotSelected } from "../../../utils/Redirect";  

const Introduction = props => {

    ScrollToTop();
    RedirectIfCaptchaNotSelected(props);

    const dispatch = useDispatch();
    const importExportDetails = useSelector(state => state.importExportDetails);

    const [showErrors, setShowErrors] = useState(false);
    
    const [ieType, setIeType] = useState(importExportDetails ? importExportDetails.ieType : null);
    const [appType, setAppType] = useState(importExportDetails ? importExportDetails.appType : null);

    const importExportValues = [
        {
            value: 'Import',
            label: 'Import'
        },
        {
            value: 'Export',
            label: 'Export'
        }
    ];

    const applicationTypeValues = [
        {
            value: 'Individual',
            label: 'Individual'
        }
    ];

    const validators = [
        {
            fieldName: "ieType",
            fieldValue: ieType,
            isValid: (v) => (isSelected(v)),
        },
        {
            fieldName: "appType",
            fieldValue: appType,
            isValid: (v) => (isSelected(v)),
        },
      ];

    const [errors, setErrors] = useState({
        ieType: false,
        appType: false,
    });

    const storeData = () => {

        const importExportDetailsData = {
            ieType: ieType,
            appType: appType,
        }

        dispatch(storeImportExportDetails(importExportDetailsData));

    };

    const startButtonHandler = () => {

        if (validate(validators, setErrors)) {
            setShowErrors(false);
            storeData();
            if(appType === 'Individual')
            {
                props.history.push('/import-export/individual-licence-information')
            }
            if(appType === 'Organisation')
            {
                props.history.push('/import-export/organisation-dashboard')
            }
        } else {
            setShowErrors(true);
            scrollToError();
        }
    }

    const renderSection = () => {
        return <div className={styles.section}>
            <div className={"row"}>
                <div className={'col-12'}>
                    <h3>Are you applying for an Import or Export Licence?</h3>
                    <RadioSelector
                        options={importExportValues}
                        onSelectionChange={(selectedValue) => {
                            setIeType(selectedValue);              
                        }}
                        initialValue={ieType}
                    />
                    
                </div>
                {ieType==null && errors.ieType && showErrors ? (
                    <div className={`col-12 ${styles.errorContainer}`}>
                    <ErrorMsg 
                        className={"ErrorMsg_error"}
                        type={"error"}
                        description={"Please make a selection."}
                    />
                    </div>
                ) : null}                
            </div>
            <div className={"row"}>
                <div className={'col-12'}>
                    <h3>Are you an Individual Applicant or applying on behalf of a Business?</h3>
                    <RadioSelector
                        options={applicationTypeValues}
                        onSelectionChange={(selectedValue) => {
                            setAppType(selectedValue);              
                        }}
                        initialValue={appType}
                    />
                    <br/>
                    <p><i>Organisations cannot currently apply online for an Import/Export licence. If you are applying on behalf of a business, please go to the <br/>
                       <a href='https://www.environment.nsw.gov.au/licences-and-permits/wildlife-licences/trading-in-native-animals/licences-to-transport-native-animals-interstate' target='blank'>Licence to transport animals interstate</a> webpage
                        and download the application form found
                        under the heading ‘Apply by email or post’</i>.
                    </p>
                </div>
                {appType==null && errors.appType && showErrors ? (
                    <div className={`col-12 ${styles.errorContainer}`}>
                    <ErrorMsg 
                        className={"ErrorMsg_error"}
                        type={"error"}
                        description={"Please make a selection."}
                    />
                    </div>
                ) : null}                
            </div>                 

            <div className={"row justify-content-end"}>
                <div className={`col-3 ${styles.buttonSection}`}>
                    <Button onClick={() => startButtonHandler()}>
                            Start
                    </Button>
                </div>
            </div>          
        </div>
      }    
  
    return <div className={styles.mainCont}>
      <div className={'row'}>
        <div className={`col-12`}>
          <h1>Apply for Import / Export Licence</h1>
          {renderSection()}
        </div>
      </div>
    </div>
  };
  
  export default withRouter(props => <Introduction {...props}/>);
  
